import { ProfileDetailContent } from "PFApp/booking/components/details_panel/detail_view/profile_detail/profile_detail_content";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useProfile } from "PFCore/hooks/queries/profile/use_profile";
import React from "react";

import { DetailsSidePanelProps } from "../../details_panel_item";
import { ProfileDetailHeader } from "./profile_detail_header";

export const ProfileDetailsSidePanel = React.memo(
  ({
    isOnTop,
    show,
    data,
    onClose,
    zIndex,
    isClosing,
    disableEntranceAnimation = false
  }: DetailsSidePanelProps) => {
    const { data: profile } = useProfile(data?.id, { enabled: show && !!data?.id });
    const { calendarRange: bookingModuleCalendarRange } = data.bookingModuleDetails ?? {};
    return (
      <SidePanel
        show={show}
        zIndex={zIndex}
        onClose={onClose}
        isSidePanelClosing={isClosing}
        title={profile && <ProfileDetailHeader profile={profile} />}
        isOnTop={isOnTop}
        disableEntranceAnimation={disableEntranceAnimation}
      >
        <ProfileDetailContent data={data} bookingModuleCalendarRange={bookingModuleCalendarRange} />
      </SidePanel>
    );
  }
);

ProfileDetailsSidePanel.displayName = "ProfileDetailsSidePanel";
